const toBase64 = (str) => {
  if (typeof window === 'undefined') {
    return Buffer.from(str).toString('base64');
  }
  // eslint-disable-next-line no-undef
  return window.btoa(str);
};

export default toBase64;
